let environment: Environment;

switch (window.location.hostname) {
	case "mfx-dev.m-daq.com":
		environment = {
			MFX_BASE_URL: "https://mfx-price-store-dev.s3.ap-southeast-1.amazonaws.com/prices.json",
		};
		break;

	case "mfx-uat.m-daq.com":
		environment = {
			MFX_BASE_URL: "https://mfx-price-store-uat.s3.ap-southeast-1.amazonaws.com/prices.json",
		};
		break;

	case "mfx.m-daq.com":
		environment = {
			MFX_BASE_URL: "https://mfx-price-store-prod.s3.ap-southeast-1.amazonaws.com/prices.json",
		};
		break;

	default:
		environment = {
			MFX_BASE_URL: "https://mfx-price-store-prod.s3.ap-southeast-1.amazonaws.com/prices.json",
		};
}

interface Environment {
	MFX_BASE_URL: string;
}

export default environment;
